import { Component, OnInit } from '@angular/core';
import { ProfileService } from './profile.service';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';
declare var $ : any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  loading: boolean = true;
  submitSuccess: boolean = false;
  isError: boolean = false;
  userProfile: any;
  submitted: boolean = false;

  constructor(private profileService: ProfileService) { }

  ngOnInit() {
    $('#loadProfileSpinner').show();
    this.loading = true;
    this.submitSuccess = false;
    this.isError = false;
    this.getProfile();
  }

  getProfile(){
    this.profileService.getProfile()
      .subscribe(
        (data:any) => {
          console.log(data);
          this.userProfile = data;
          this.loading = false;
          $('#loadProfileSpinner').hide();
        },
        (err:HttpErrorResponse) => {
          console.log(err);
          $('#loadProfileSpinner').hide();
          this.loading = false;
        }
      );
  }

  OnSubmit()
  {
      this.submitSuccess = false;
      this.isError = false;
      console.log(this.userProfile);
      this.profileService.updateProfile(this.userProfile)
        .subscribe(
          (data:any) => {this.submitSuccess = true;},
          (err:HttpErrorResponse) => {console.log(err); this.isError = true;}
        );
  }
  
  toggleBox(event)
  {
    console.log(event.target.checked);
    console.log(this.userProfile);
  }
}
